import { useEffect, useState } from 'react';
import { DBRequest, useConfig } from '../../../api/api';
import { Box, Divider } from '@mui/material';
import TypeCustomSelect from '../../../components/form/form-fields/TypeCustomSelect';
import { useTranslation } from 'react-i18next';
import { SalesObjectPreview } from '../../../open-scenes/sales-object-customer-view/SalesObjectPreview';
import Loader from '../../../components/special/Loader';

export const SalesObjectCustomerPreview = ({ salesObject }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const [level, setLevel] = useState(0);
  const [previewData, setPreviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleLoadCustomerPreview(level);
  }, [salesObject, config]);

  function handleLoadCustomerPreview(newLevel) {
    DBRequest({
      config,
      path: `sales-objects/${salesObject.id}/preview/${newLevel}`,
      onResponse: setPreviewData,
      onLoading: setIsLoading,
    });
  }

  function handleChange(key, value) {
    setLevel(value);
    handleLoadCustomerPreview(value);
  }

  // map keeps the first occurrence of each unique level.
  const uniqueLevelsMap = new Map();
  salesObject.levels.forEach((obj) => {
    if (!uniqueLevelsMap.has(obj.accessLevel)) {
      uniqueLevelsMap.set(obj.accessLevel, obj);
    }
  });

  //Sort as per levels
  const sortedLevels = Array.from(uniqueLevelsMap.values()).sort(
    (a, b) => a.accessLevel - b.accessLevel
  );

  const options = Array.from(sortedLevels.values()).map((obj) => ({
    label: (
      <>
        <span className="monospace mr-1" style={{ fontWeight: 600 }}>
          {obj.accessLevel}
        </span>
        {` - ${t(obj.title)}`}
      </>
    ),
    value: obj.accessLevel,
  }));

  return (
    <Box className="h-full flex flex-col w-full justify-center gap-2 relative pt-2">
      {/*<Loader active={isLoading} />*/}
      <TypeCustomSelect
        field={{
          label: t('Sales level'),
          key: 'level',
          options,
          noUnselect: true,
        }}
        dataCollection={{ level }}
        updateValidationOnChange={handleChange}
      />
      <Divider />
      <Box className="flex flex-col h-full overflow-y-auto">
        <SalesObjectPreview
          isLoading={isLoading}
          salesObject={previewData?.data}
        />
      </Box>
    </Box>
  );
};
